import { ReportTeams } from '@/app/services/reportService/reportTeams'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import { formatName } from '@/app/utils/formatName'
import { createColumnHelper } from '@tanstack/react-table'

const columnHelper = createColumnHelper<ReportTeams>()

const columns = [
  columnHelper.accessor('name', {
    id: 'name',
    header: () => (
      <div className="flex w-full flex-col items-start gap-1 pl-2">
        <div>Nome</div>
        <div className="block text-black04 xl:hidden">Gerente</div>
        <div className="block text-black04 lg:hidden">Supervisor</div>
        <div className="block text-black04 md:hidden">Líder</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex w-full flex-col items-start gap-1 pl-4">
        <div>{row.original.name}</div>
        <div className="block text-black04 xl:hidden">
          {row?.original?.manager ? formatName(row.original.manager) : '-'}
        </div>
        <div className="block text-black04 lg:hidden">
          {row?.original?.supervisor
            ? formatName(row.original.supervisor)
            : '-'}
        </div>
        <div className="block text-black04 md:hidden">
          {row?.original?.leader ? formatName(row.original.leader) : '-'}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('manager', {
    id: 'manager',
    header: () => <div className="hidden text-left xl:block">Gerente</div>,
    cell: ({ row }) => (
      <div className="hidden text-left xl:block">
        {row?.original?.manager ? formatName(row.original.manager) : '-'}
      </div>
    ),
  }),
  columnHelper.accessor('supervisor', {
    id: 'leader',
    header: () => <div className="hidden text-left lg:block">Supervisor</div>,
    cell: ({ row }) => (
      <div className="hidden text-left lg:block">
        {row?.original?.supervisor ? formatName(row.original.supervisor) : '-'}
      </div>
    ),
  }),
  columnHelper.accessor('leader', {
    id: 'leader',
    header: () => <div className="hidden text-left md:block">Líder</div>,
    cell: ({ row }) => (
      <div className="hidden text-left md:block">
        {row?.original?.leader ? formatName(row.original.leader) : '-'}
      </div>
    ),
  }),
  columnHelper.accessor('members', {
    id: 'members',
    header: () => (
      <div className="flex w-full flex-col items-end gap-1 pr-2 sm:items-center sm:pr-0">
        <div>Vendedores</div>
        <div className="block text-black04 md:hidden">Comissões</div>
        <div className="block text-black04 sm:hidden">Movimentado</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex w-full flex-col items-end gap-1 pr-4 sm:items-center sm:pr-0">
        <div>{row.original.members}</div>
        <div className="block text-black04 md:hidden">
          {formatMoneyValue(row.original.commission_value)}
        </div>
        <div className="block text-black04 sm:hidden">
          {formatMoneyValue(row.original.transactions_value)}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('transactions', {
    id: 'transactions',
    header: () => (
      <div className="hidden sm:block">
        <div className="flex w-full flex-col items-center gap-1">
          <div>Transações</div>
        </div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="hidden sm:block">
        <div className="flex w-full flex-col items-center gap-1">
          <div>{row.original.transactions}</div>
          <div className="block text-black04 2xl:hidden">
            {formatMoneyValue(row.original.transactions_value)}
          </div>
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('transactions_value', {
    id: 'transactions_value',
    header: () => (
      <div className="hidden text-center 2xl:block">Movimentado</div>
    ),
    cell: ({ row }) => (
      <div className="hidden text-center 2xl:block">
        {formatMoneyValue(row.original.transactions_value)}
      </div>
    ),
  }),
  columnHelper.accessor('commission_value', {
    id: 'comissions_value',
    header: () => <div className="hidden text-center md:block">Comissões</div>,
    cell: ({ row }) => (
      <div className="hidden text-center md:block">
        {formatMoneyValue(row.original.commission_value)}
      </div>
    ),
  }),
]

export const TableReportTeamsColumnsDefinition = () => {
  return {
    columns,
  }
}
